/**
 * AnimatedSprite2D parser: the Node2D transform and the SpriteFrames playback
 * properties. The SpriteFrames resource itself decodes at render time, from the
 * resolved sub- or ext-resource.
 */
import { unquoteLiteral } from '../../../parser/utils';
import { parseNode2D } from '../../base/node2d/parser';
import { boolOr, intOr, vec2Or } from '../../../parser/valueParsers';
import { holdsResource } from '../../../godot/scene/resourceLiteral.js';
export function parseAnimatedSprite2D(heading, properties) {
    const base = parseNode2D(heading, properties);
    const result = {
        ...base,
        frame: intOr(properties.frame, 0),
        centered: boolOr(properties.centered, true),
        offset: vec2Or(properties.offset, { x: 0, y: 0 }, 'AnimatedSprite2D'),
        flip_h: boolOr(properties.flip_h, false),
        flip_v: boolOr(properties.flip_v, false),
    };
    if (holdsResource(properties.sprite_frames))
        result.sprite_frames = properties.sprite_frames;
    // `animation = &"right"` → "right", read as the SpriteFrames decoder reads the name it matches.
    if (properties.animation)
        result.animation = unquoteLiteral(properties.animation);
    return result;
}
//# sourceMappingURL=parser.js.map